import React from "react";
import { Checkbox } from "antd";
import { Icon } from "Components";
import Icons from "Components/Icon/Icons";

interface Props {
    itemKey: string;
    title: string;
    description: string;
    iconType: keyof typeof Icons;
    isChecked: boolean;
    onToggle: (key: string) => void;
}

const RecipientItem: React.FC<Props> = ({
    itemKey,
    title,
    description,
    iconType,
    isChecked,
    onToggle,
}) => (
    <div
        className="phishing-step3__role-item"
        onClick={() => onToggle(itemKey)}
    >
        <Checkbox
            checked={isChecked}
            onChange={() => onToggle(itemKey)}
            onClick={(e) => e.stopPropagation()}
        />
        <div className="phishing-step3__role-info">
            <div className="phishing-step3__role-title">
                <Icon type={iconType} />
                <span className="phishing-step3__role-text">{title}</span>
            </div>
            <span className="phishing-step3__role-desc">{description}</span>
        </div>
    </div>
);

export default RecipientItem;